module.exports = __webpack_public_path__ + "img/jyh弹窗 (1).aebb4271.png";